import React from 'react';
import { cn } from '../utils/cn';
export const Skeleton = React.forwardRef(function Skeleton(
  { variant = 'line', width, height, className, style, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn(
        'animate-pulse bg-neutral-200',
        variant === 'line' && 'h-4 w-full rounded',
        variant === 'circle' && 'h-10 w-10 rounded-full',
        variant === 'rect' && 'h-24 w-full rounded-lg',
        className,
      )}
      style={{
        width,
        height,
        ...style,
      }}
      {...props}
    />
  );
});
